import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function Login() {
  const { user, loading, login, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && user && user.is_admin) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/login", { username, password });
      await checkAuth();
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invalid username or password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-login" data-testid="login-page">
      <div className="admin-login-card">
        <h1>San Juanillo Rising</h1>
        <p>Admin sign in</p>

        <form onSubmit={submit} className="admin-login-form">
          <input
            className="editor-input"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            data-testid="login-username-input"
          />
          <input
            className="editor-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            data-testid="login-password-input"
          />
          {error ? <p className="admin-login-error" data-testid="login-error">{error}</p> : null}
          <button className="btn-primary" type="submit" disabled={submitting} data-testid="login-submit-btn">
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="admin-login-divider"><span>or</span></div>

        <button className="btn-ghost" onClick={login} data-testid="google-login-btn">
          Sign in with Google
        </button>
        <a href="/" className="admin-login-back">&larr; Back to site</a>
      </div>
    </div>
  );
}
